Pegasus.TemplatePreviewController = Ember.ObjectController.extend({
  needs: ['template', 'toolbar'],
  isPreviewOnly: function(){
    return !!( this.get('template_preview_id') );
  }.property('template_preview_id'),
  isPreviewRestricted: function(){
    return this.get('content.state') !== 'draft' && this.get('content.state') !== 'paused';
  }.property('content.state'),
  frameSrc: function(){
    return this.get('controllers.template.activeDocument.preview_url') || '';
  }.property('controllers.template.activeDocument.preview_url'),
  template: function(){
    return this.get('controllers.template.content');
  }.property('controllers.template.content'),
  templateType: function(){
    return this.get('template').constructor.toString().split('.').get('lastObject').dasherize();
  }.property('template'),
  defaultActiveType: 'desktop',
  activeType: 'desktop',
  rotated: false,
  didChangeActiveType: function(){
    if( this.get('activeType') === 'exit' ){
      this.send('didExitPreview');
      this.resetActiveType();
      return;
    }
  }.observes('activeType'),
  resetActiveType: function(){
    this.set('activeType', this.get('defaultActiveType'));
  },
  isMobile: Em.computed.equal( 'activeType', 'phone'),
  isDesktop: Em.computed.equal('activeType', 'desktop'),
  isTablet: Em.computed.equal( 'activeType', 'tablet')
});
